<template>
  <div>
    <div class="mt-4 mb-5 text-left">
      <h3 class="text-lg mb-1">Bienvenido de nuevo</h3>
      <p class="text-md text-muted">Inicia sesión para acceder a su casillero de compras internacionales.</p>
    </div>
    <form @submit.prevent="AUTH()">
      <div class="form-group mb-2">
        <small class="input-title">Correo electrónico</small>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <i class="bi bi-envelope"></i>
            </span>
          </div>
          <input type="email" class="form-control" name="email" v-model="data.email" :class="errors.email ? 'is-invalid' : ''">
          <small class="invalid-feedback" v-for="(error, index) in errors.email" :key="index">{{ error
          }}</small>
        </div>
      </div>
      <div class="form-group mb-3">
        <small class="input-title">Contraseña</small>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <i class="bi bi-lock"></i>
            </span>
          </div>
          <v-text-field v-model="data.password" name="password" :append-icon="type ? 'mdi-eye' : 'mdi-eye-off'"
            :type="type ? 'text' : 'password'" class="form-control" hide-details @click:append="type = !type"
            :class="errors.password ? 'is-invalid' : ''">
          </v-text-field>
          <small class="invalid-feedback" v-for="(error, index) in errors.password" :key="index">{{ error
          }}</small>
        </div>
      </div>
      <div class="form-group d-flex justify-content-end">
        <div class="mb-2 ml-auto mr-0"><router-link :to="{ name: 'ForgetPassword' }">¿Olvidaste tu
            contraseña?</router-link></div>
      </div>
      <div class="form-group">
        <button type="submit" class="btn btn-primary btn-x w-100">
          <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
            <span class="sr-only">Loading...</span>
          </div>
          <span v-else>Iniciar sesión</span>
        </button>
      </div>
    </form>
    <div class="mt-4 d-flex justify-content-start gap-2">
      <div class="mb-3">¿No tiene una cuenta? <router-link :to="{ name: 'Register' }">Afiliarme</router-link></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      type: false,
      data: {
        email: '',
        password: ''
      },
      errors: {},
      count: 0
    }
  },
  computed: {
    ...mapGetters([
      'permissions'
    ])
  },
  methods: {
    AUTH: function () {
      let vue = this
      vue.count++
      vue.errors = {}
      if (vue.count == 1) {
        axios({ url: '/login', method: 'POST', data: vue.data })
          .then((resp) => {
            if(resp.data.slug){
              vue.$router.push({ name: 'Thanks', params: { slug: resp.data.slug } })
            }else{
              vue.$store.dispatch('INIT_USER', resp.data)
              if (vue.permissions[0]) {
                if (vue.permissions[0].items.length > 0) {
                  vue.$router.push({ name: vue.permissions[0].items[0].route })
                } else {
                  vue.$router.push({ name: vue.permissions[0].route })
                }
              } else {
                vue.$router.push({ name: 'P403' })
              }
            }
          })
          .catch((err) => {
            if (err.response.status !== 422) {
              let message = err.response ? err.response.data.message : err.message
              vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
            } else {
              vue.errors = err.response.data
            }
          })
          .finally((resp) => {
            vue.count = 0
          })
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/auth/Login.vue